{
  " Because it is a one-way hash, your code cannot be reverse-engineered.": " 因为是单向哈希，您的代码无法被逆向工程。",
  " and add this step to your deployment workflow.": " 并将此步骤添加到您的部署工作流中。",
  " proofs and audit ledgers to your designated Shadow Repositories.": " 将证明和审计账本推送至您指定的影子仓库。",
  " proofs and daily audit ledgers. We require ": " 证明和每日审计账本。我们要求 ",
  " proofs in your Shadow Repository will remain your property.": " 影子仓库中的证明仍归您所有。",
  " receipts and daily audit ledgers to your Shadow Repository.": " 将收据和每日审计账本推送到您的影子仓库。",
  " to this specific repository only.": " 仅限于此特定仓库。",
  " where we push your cryptographic ": " 我们将您的加密证明推送至 ",
  " you had an idea, without ever showing us the idea itself.": " 您曾有过一个创意，而无需向我们展示创意本身。",
  "#": "#",
  "(\"we\", \"our\", or \"us\"), privacy and security are the foundational principles of our architecture. We provide a zero-knowledge cryptographic timestamping service designed to prove the existence of your intellectual property without ever requiring access to the intellectual property itself.": "（“我们”），隐私和安全是我们架构的基本原则。我们提供零知识加密时间戳服务，旨在证明您知识产权的存在，而无需访问知识产权本身。",
  "(c) 2026 RSJ Software GmbH - Germering, Germany": "(c) 2026 RSJ Software GmbH - 德国盖默林",
  "(c) 2026 RSJ Software GmbH - Germering, Germany - All Intellectual Property Protected via Bitcoin.": "(c) 2026 RSJ Software GmbH - 德国盖默林 - 所有知识产权均受比特币保护。",
  "(c) 2026 RSJ Software GmbH. All rights reserved.": "(c) 2026 RSJ Software GmbH. 保留所有权利。",
  "+49 89 89 41 42-0": "+49 89 89 41 42-0",
  "+49 89 89 41 42-80": "+49 89 89 41 42-80",
  ". It is a permanent record.": ". 这是一份永久记录。",
  "/forever": "/永久",
  "/month": "/月",
  "1 Public GitHub Repository": "1 个公共 GitHub 仓库",
  "1,245 Commits": "1,245 次提交",
  "1. Acceptance of Terms": "1. 条款的接受",
  "1. Our Zero-Knowledge Guarantee": "1. 我们的零知识保证",
  "1. The Source": "1. 来源",
  "10. Contact Information": "10. 联系信息",
  "100% internal network execution": "100% 内部网络执行",
  "2 hours ago": "2小时前",
  "2. Description of Service": "2. 服务说明",
  "2. Information We Collect": "2. 我们收集的信息",
  "2. The Monolith Engine": "2. 单体引擎",
  "3. How We Use Your Information": "3. 我们如何使用您的信息",
  "3. Intellectual Property": "3. 知识产权",
  "3. The Destination": "3. 目的地",
  "4. Fees and Payment": "4. 费用与支付",
  "4. How We Share Your Information": "4. 我们如何共享您的信息",
  "412 Commits Sealed": "412 次提交已封存",
  "5. Blockchain Specific Provisions": "5. 区块链特别条款",
  "5. Data Retention and Deletion": "5. 数据保留与删除",
  "6. Prohibited Conduct": "6. 禁止行为",
  "6. Your Data Protection Rights": "6. 您的数据保护权利",
  "7. Limitation of Liability": "7. 责任限制",
  "7. Self-Hosted / Docker Environments": "7. 自托管 / Docker 环境",
  "8. Changes to This Privacy Policy": "8. 本隐私政策的变更",
  "8. Enterprise Docker License": "8. 企业版 Docker 许可证",
  "82110 Germering": "82110 盖默林",
  "9. Contact Us": "9. 联系我们",
  "9. Termination": "9. 终止",
  "A 12-line GitHub Action runs on your servers and PUSHES the commit hash to our API.": "一个 12 行的 GitHub Action 在您的服务器上运行，并将提交哈希推送到我们的 API。",
  "A. Information You Provide to Us": "A. 您向我们提供的信息",
  "A. Your Content": "A. 您的内容",
  "API Reference": "API 参考",
  "About": "关于",
  "Account Data:": "账户数据：",
  "Account Deletion:": "账户删除：",
  "Account Information:": "账户信息：",
  "Add a cryptographically verifiable badge to your README.": "为您的 README 添加可加密验证的徽章。",
  "Action": "操作",
  "Actions": "操作",
  "Active": "活跃",
  "Add Repository": "添加仓库",
  "Add your API key as a repository secret named ": "将您的 API 密钥添加为名为“”的仓库机密 ",
  "All commits in this repository are cryptographically timestamped and anchored to the Bitcoin blockchain using ": "此仓库中的所有提交都经过加密时间戳标记，并使用以下方式锚定到比特币区块链： ",
  "Analyzing usage trends to optimize our dashboard and Docker images.": "分析使用趋势以优化我们的仪表板和 Docker 镜像。",
  "Anchored in Block #834102": "已锚定于区块 #834102",
  "Annually": "按年",
  "App Name": "应用名称",
  "Appears on local audit PDF exports.": "显示在本地审计 PDF 导出中。",
  "Append (Right)": "追加（右）",
  "Applying...": "正在应用...",
  "At Timestamp GIT, operated by": "Timestamp GIT，由以下机构运营：",
  "Attempt to reverse-engineer or disrupt our batching and anchoring engine.": "尝试对我们的批处理和锚定引擎进行逆向工程或破坏。",
  "Audit Guide": "审计指南",
  "B. Data Collected via Our Services": "B. 通过我们的服务收集的数据",
  "B. Our Service": "B. 我们的服务",
  "Because you can verify all 42 levels locally, you never need to expose your source code to us.": "因为您可以在本地验证全部 42 个层级，所以永远无需向我们暴露源代码。",
  "Before detailing standard data collection practices, we want to explicitly state our core security guarantee regarding your source code:": "在详细说明标准数据收集实践之前，我们想明确说明关于您源代码的核心安全保证：",
  "Beta": "测试版",
  "Billing Information:": "账单信息：",
  "Billing:": "账单：",
  "Bitcoin Block Reference": "比特币区块引用",
  "Bitcoin Network": "比特币网络",
  "Bitcoin Tx Anchor": "比特币交易锚定",
  "Block #834102": "区块 #834102",
  "Block #{{block}} confirmed": "区块 #{{block}} 已确认",
  "Blockchain Immutability:": "区块链不可变性：",
  "Blockchain anchors are permanent. They cannot be deleted or \"undone\".": "区块链锚定是永久的。它们无法被删除或“撤销”。",
  "Blog": "博客",
  "Broadcast to Bitcoin Network": "广播至比特币网络",
  "Builds Merkle Tree natively": "原生构建 Merkle 树",
  "By Date (e.g., /2026/03/18/proofs)": "按日期（例如：/2026/03/18/proofs）",
  "By Repository (e.g., /frontend-app/2026/proofs)": "按仓库（例如：/frontend-app/2026/proofs）",
  "By creating an account or using our services, you confirm that you can form a binding contract with Timestamp GIT and RSJ Software GmbH. If you are using the services on behalf of an organization, you agree to these Terms on behalf of that organization.": "创建账户或使用我们的服务，即表示您确认能够与 Timestamp GIT 和 RSJ Software GmbH 签订具有约束力的合同。如果您代表组织使用服务，则表示您代表该组织同意这些条款。",
  "By using this service, you acknowledge and agree to the unique properties of blockchain technology:": "使用本服务即表示您确认并同意区块链技术的独特属性：",
  "C. Automatically Collected Information": "C. 自动收集的信息",
  "Calculatable Verification": "可计算验证",
  "Calculate SHA-256": "计算 SHA-256",
  "Calendar Server Node": "日历服务器节点",
  "Chain of Trust Landmarks": "信任链地标",
  "Changes:": "变更：",
  "Choose how you want proofs organized inside your Shadow Repo.": "选择您希望证明在影子仓库中的组织方式。",
  "Click \"Verify\" to load the row into the calculator above. Hash it to match the next row.": "点击“验证”将行加载到上面的计算器中。对其进行哈希以匹配下一行。",
  "Click to verify anchors": "点击验证锚定",
  "Commit": "提交",
  "Commit:": "提交：",
  "Coming Soon": "即将推出",
  "Company": "公司",
  "Company Information": "公司信息",
  "Compile Python to native and protect your source code.": "将 Python 编译为原生代码并保护您的源代码。",
  "Included free during the Pro beta (until 31 Dec 2026).": "Pro 测试期间免费包含（至 2026 年 12 月 31 日）。",
  "More Products": "更多产品",
  "OpenTimestamps": "OpenTimestamps",
  "OpenTimestamps and Bitcoin make blockchain timestamp verification automatic. This is how to prove code existed at a specific time, without revealing the code.": "OpenTimestamps 与 Bitcoin 让区块链时间戳验证实现自动化。这就是在特定时间点证明代码已存在、且无需公开代码的方法。",
  "opentimestamps.org": "opentimestamps.org",
  "Pro beta: all Pro features are free until 31 December 2026": "Pro 测试版：所有 Pro 功能免费使用至 2026 年 12 月 31 日",
  "Py2Native": "Py2Native",
  "Competitors often claim they \"independently developed\" a similar feature. Proving you had the finished logic in your repository 18 months prior creates a mathematical wall they cannot climb.": "竞争对手常常声称他们“独立开发”了类似功能。证明您在 18 个月前已将完整逻辑存入仓库，将为他们筑起一道无法逾越的数学之墙。",
  "Concept": "概念",
  "Configuration": "配置",
  "Connected Shadow Repository": "已连接的影子仓库",
  "Connects to GitHub or GitHub Enterprise Server": "连接到 GitHub 或 GitHub Enterprise Server",
  "Connects to OTS Calendars": "连接到 OTS 日历",
  "Contact": "联系",
  "Contact Sales": "联系销售",
  "Convert your demo instance to full Enterprise support.": "将您的演示实例转换为完整的企业版支持。",
  "Cookies and Tracking:": "Cookie 和跟踪：",
  "Copied!": "已复制！",
  "Copy Markdown": "复制 Markdown",
  "Copy Output": "复制输出",
  "Copy to clipboard": "复制到剪贴板",
  "Court-Ready Evidence": "可呈堂证据",
  "Coverage": "覆盖范围",
  "Created": "已创建",
  "Credentials or OAuth tokens granting us the explicit, scoped Write Access required to push ": "授予我们推送所需的明确、限定范围的写入访问权限的凭据或 OAuth 令牌 ",
  "Credit card details and billing address (processed securely via our third-party payment processors like Stripe; we do not store full credit card numbers).": "信用卡信息和账单地址（通过 Stripe 等第三方支付处理商安全处理；我们不存储完整的信用卡卡号）。",
  "Critical IP Risks": "关键知识产权风险",
  "Cryptographic Hashes:": "加密哈希：",
  "Cryptographic Merkle Root": "加密 Merkle 根",
  "Cryptographic prior art": "加密现有技术",
  "Current Result (Middle)": "当前结果（中间）",
  "DOWNLOAD FULL AUDIT LEDGER (CSV)": "下载完整审计账本 (CSV)",
  "DOWNLOAD PDF CERTIFICATE": "下载 PDF 证书",
  "Daily Bitcoin Batching": "每日比特币批处理",
  "Daily Operations Model": "每日运营模式",
  "Daily Regularity": "每日定期执行",
  "Date": "日期",
  "Days": "天",
  "Decentralization:": "去中心化：",
  "Dedicated Account Manager": "专属客户经理",
  "Defend reusable library code from being claimed.": "保护可复用的库代码不被主张权利。",
  "Demo": "演示",
  "Depending on your location (e.g., GDPR, CCPA), you may have rights regarding access, rectification, objection, and portability of your personal data.": "根据您所在的位置（例如 GDPR、CCPA），您可能享有访问、更正、反对和转移个人数据的权利。",
  "Deploy Timestamp GIT on your own infrastructure for maximum security and air-gapped environments.": "在您自己的基础设施上部署 Timestamp GIT，以获得最大安全性和气隙环境。",
  "Deploy the entire Timestamp GIT engine behind your own firewall using our official Docker image. Connects to public GitHub or GitHub Enterprise Server. Perfect for heavily regulated industries.": "使用我们的官方 Docker 镜像，在您自己的防火墙后面部署完整的 Timestamp GIT 引擎。可连接公共 GitHub 或 GitHub Enterprise Server。非常适合监管严格的行业。",
  "Destination Repository": "目标仓库",
  "Detailed Coverage Timeline": "详细覆盖时间线",
  "Dev Shops & Agencies": "开发公司与代理机构",
  "Directory Structure": "目录结构",
  "Disconnect Shadow Repo": "断开影子仓库",
  "Docker Compose Installation": "Docker Compose 安装",
  "Docker Self-Hosted License": "Docker 自托管许可证",
  "Docker Server": "Docker 服务器",
  "Don't Leave Your IP to Chance": "不要让您的知识产权听天由命",
  "Don't use our service to timestamp illegal content or spam.": "请勿使用我们的服务对非法内容或垃圾信息进行时间戳标记。",
  "Download PDF Report": "下载 PDF 报告",
  "Downloadable PDF Audit Reports": "可下载的 PDF 审计报告",
  "Downloads & Exports": "下载与导出",
  "E-Mail:": "电子邮件：",
  "Each active square represents a day where commits were anchored to Bitcoin.": "每个活动的方格代表提交被锚定到比特币的一天。",
  "Earliest Anchor": "最早的锚定",
  "Effective Date: March 18, 2026": "生效日期：2026年3月18日",
  "Email": "邮箱",
  "Embed the Viral Badges": "嵌入病毒式徽章",
  "Enterprise": "企业版",
  "Enterprise Docker": "企业版 Docker",
  "Enterprise License Active": "企业版许可证已激活",
  "Enterprise License Applied": "企业版许可证已应用",
  "Enterprise ZK": "企业版 ZK",
  "Enterprise ZK Integration": "企业版 ZK 集成",
  "Easy access to status information via status badges that can be embedded directly in your README.md.": "通过可直接嵌入 README.md 的状态徽章，轻松访问状态信息。",
  "Everything in Free, plus:": "包含 Free 的所有功能，另加：",
  "Everything in Open Source, plus:": "包含 Open Source 的所有功能，另加：",
  "Everything in Pro, plus:": "包含 Pro 的所有功能，另加：",
  "Fax:": "传真：",
  "Fees are billed in advance on a monthly or annual basis depending on your plan.": "费用根据您的套餐按月或按年预付。",
  "Fill out the form below to receive a time-limited demo license for evaluation.": "填写以下表格，即可获得用于评估的限时演示许可证。",
  "First prior-art anchor recorded": "首个现有技术锚定已记录",
  "Flat List (Not recommended for large workspaces)": "平面列表（不建议用于大型工作区）",
  "For Enterprise customers utilizing our Self-Hosted Docker deployment:": "对于使用我们自托管 Docker 部署的企业版客户：",
  "For customers using our Self-Hosted Docker deployment: The license is limited to the number of instances specified in your Enterprise contract. You are responsible for the security and maintenance of the environment where the Docker container is deployed.": "对于使用我们自托管 Docker 部署的客户：许可证仅限于企业合同中指定的实例数量。您负责 Docker 容器部署环境的安全和维护。",
  "For dev shops and startups building proprietary IP.": "适用于构建专有知识产权的开发公司和初创企业。",
  "For open-source projects and public repositories.": "适用于开源项目和公共仓库。",
  "Fork": "Fork",
  "Former Employee Disputes": "前雇员纠纷",
  "Free": "Free",
  "Freelance Developers": "自由开发者",
  "Full control of Bitcoin anchoring schedules": "完全控制比特币锚定计划",
  "Generate New Key": "生成新密钥",
  "Generating Merkle trees and anchoring hashes to the Bitcoin blockchain.": "正在生成 Merkle 树并将哈希锚定到比特币区块链。",
  "Germany": "德国",
  "Get Started": "开始使用",
  "Get Status Badge": "获取状态徽章",
  "GitHub Action Implementation": "GitHub Action 实现",
  "GitHub App": "GitHub App",
  "GitHub App Settings": "GitHub App 设置",
  "Go to your GitHub App settings to grant access to repositories.": "前往您的 GitHub App 设置以授予仓库访问权限。",
  "GitHub App reads the ": "GitHub App 读取 ",
  "Groups all pending hashes": "将待处理的哈希分组",
  "HEAD commit hash of the monitored repository automatically.": "自动读取被监控仓库的 HEAD 提交哈希。",
  "HOW IT WORKS": "工作原理",
  "Hash Queue": "哈希队列",
  "Hash result will appear here...": "哈希结果将显示在此处...",
  "Here is a quick example of how to initialize the model in your application:": "以下是如何在应用程序中初始化模型的快速示例：",
  "Holzstrasse 4": "Holzstrasse 4",
  "How we mathematically secure your prior art on the Bitcoin blockchain using a lean, single-container deployment and secure Shadow Repos.": "我们如何通过精简的单容器部署和安全影子仓库，在比特币区块链上以数学方式保护您的现有技术。",
  "IP Protection Badge": "知识产权保护徽章",
  "IP addresses, browser types, operating systems, referring URLs, and interaction data.": "IP 地址、浏览器类型、操作系统、来源 URL 和交互数据。",
  "If required to do so by law or court order.": "如果法律或法院命令要求。",
  "If you choose to embed verification badges, basic metadata will be accessible via our public verification endpoints.": "如果您选择嵌入验证徽章，基本元数据将通过我们的公共验证端点可访问。",
  "If you have any questions regarding this Privacy Policy, please contact our Data Protection Officer:": "如果您对本隐私政策有任何疑问，请联系我们的数据保护官：",
  "Immutability:": "不可变性：",
  "Immutable Ledger Active": "不可变账本已激活",
  "Implementation": "实现",
  "Important As \"What\"": "与“什么”同样重要的“何时”",
  "Impressum": "版权页（Impressum）",
  "Imprint": "版权声明",
  "In the modern digital economy, your ideas are your most valuable assets. But without a mathematical timestamp, you don't own them-you're just holding them for someone else.": "在现代数字经济中，创意是您最宝贵的资产。但如果没有数学时间戳，您并不真正拥有它们——您只是在为别人保管。",
  "Increase company valuation by proving IP maturity.": "通过证明知识产权成熟度提升公司估值。",
  "Information according to Sec. 5 TMG (German Telemedia Act). Responsible for content according to Sec. 55 para. 2 RStV: Ruediger Jungbeck.": "根据德国《电信媒体法》（TMG）第 5 条提供的信息。根据 RStV 第 55 条第 2 款对内容负责：Ruediger Jungbeck。",
  "Information you provide when contacting our customer support team.": "您联系我们的客户支持团队时提供的信息。",
  "Initial Proof (Genesis)": "初始证明（创世）",
  "Input": "输入",
  "Install GitHub App": "安装 GitHub App",
  "Install the Timestamp GIT GitHub App on your repositories to get started.": "在您的仓库上安装 Timestamp GIT 的 GitHub App 即可开始。",
  "Installation": "安装",
  "Instance Network Settings": "实例网络设置",
  "Instances only communicate externally with public OpenTimestamps calendar servers and Bitcoin nodes.": "实例仅与公共 OpenTimestamps 日历服务器和比特币节点进行外部通信。",
  "It takes several hours until the transaction is confirmed in the Bitcoin blockchain.": "交易在比特币区块链中确认需要数小时。",
  "Integration": "集成",
  "Integrations": "集成",
  "Intellectual Property Notice:": "知识产权声明：",
  "Internal Git Logs": "内部 Git 日志",
  "Internal GitHub Enterprise API endpoint.": "内部 GitHub Enterprise API 端点。",
  "Internal Org Name": "内部组织名称",
  "Invert": "反转",
  "It takes 60 seconds to connect your first repository. It takes a lifetime to recover from a stolen idea.": "连接第一个仓库只需 60 秒。从被窃取的创意中恢复却需要一生。",
  "Iterate:": "迭代：",
  "Jan 15, 2026": "2026年1月15日",
  "Key Name": "密钥名称",
  "Last": "最后",
  "Last Anchored": "上次锚定",
  "Last Successful Anchor": "上次成功锚定",
  "Last Updated: March 18, 2026": "最后更新：2026年3月18日",
  "Last Used": "上次使用",
  "Latest Anchor": "最新锚定",
  "Latest Anchor Verification Data": "最新锚定验证数据",
  "Ledger": "账本",
  "Let your users know this project is cryptographically timestamped. Copy the Markdown below and paste it at the top of your ": "让您的用户知道此项目已进行加密时间戳标记。复制下面的 Markdown 并粘贴到您的 ",
  "Legal Department:": "法务部门：",
  "Legal Notice": "法律声明",
  "Legal Prior Art Verified": "法律现有技术已验证",
  "Legal Proof:": "法律证明：",
  "Legal Registry": "法律登记处",
  "Legal Representative": "法定代表人",
  "Legal Requirements:": "法律要求：",
  "Legal Whitepaper": "法律白皮书",
  "License Management": "许可证管理",
  "Limited feature set. Please upload a license file to unlock.": "功能集受限。请上传许可证文件以解锁。",
  "Live Preview": "实时预览",
  "Loaded": "已加载",
  "Loading repositories...": "正在加载仓库...",
  "Local GitHub URL": "本地 GitHub URL",
  "Log and Usage Data:": "日志和使用数据：",
  "Login": "登录",
  "Logout": "退出登录",
  "Manage your shadow repositories, tracked projects, and API keys.": "管理您的影子仓库、被跟踪的项目和 API 密钥。",
  "Management": "管理",
  "Managing Director:": "总经理：",
  "Manipulatable": "可篡改",
  "Matched": "已匹配",
  "Mathematical proof of your intellectual property doesn't have to be expensive. Protect your codebase for less than a cup of coffee.": "知识产权的数学证明不一定要昂贵。用不到一杯咖啡的钱保护您的代码库。",
  "Mathematically Absolute": "数学上绝对",
  "Mathematically Guaranteed": "数学上保证",
  "Mathematically prove milestone completion times.": "以数学方式证明里程碑完成时间。",
  "Maximum security and zero codebase access for paranoid teams.": "为高度谨慎的团队提供最大安全性和零代码库访问。",
  "Menu": "菜单",
  "Merkle Roots containing the mathematical representation of your hashes are broadcast to the Bitcoin blockchain. ": "包含哈希数学表示的 Merkle 根被广播到比特币区块链。 ",
  "Midnight Cron Worker": "午夜 Cron 工作器",
  "Monitored Repos": "被监控的仓库",
  "Monthly": "按月",
  "Months": "个月",
  "Most Popular": "最受欢迎",
  "Multiple Agency Clients": "多个代理客户",
  "Name": "姓名",
  "Name of the application as displayed in the UI": "界面中显示的应用名称",
  "Name, email address, company name, and password when you register for an account.": "注册账户时的姓名、邮箱地址、公司名称和密码。",
  "No Abuse:": "禁止滥用：",
  "No commits anchored": "无已锚定的提交",
  "No external API calls to our servers": "不向我们的服务器发起外部 API 调用",
  "No repositories found": "未找到仓库",
  "No repositories selected": "未选择仓库",
  "Non-practicing entities (trolls) often file broad patents on \"obvious\" technologies. If you implemented that tech months before their filing but have no proof, you face ruinous litigation.": "非实施实体（专利流氓）常常针对“显而易见”的技术申请宽泛的专利。如果您在他们的申请前数月就实现了该技术但没有证明，您将面临毁灭性的诉讼。",
  "Note on Service Nature:": "关于服务性质的说明：",
  "Oct 12, 2025": "2025年10月12日",
  "On-Premises Instance": "本地部署实例",
  "Once a Merkle Root is anchored to the Bitcoin blockchain, it is permanent. We cannot modify, hide, or delete these records.": "一旦 Merkle 根被锚定到比特币区块链，它就是永久的。我们无法修改、隐藏或删除这些记录。",
  "Once anchored, a hash ": "一旦锚定，哈希 ",
  "Open Source": "开源",
  "Operator": "运营方",
  "Optional contact number": "可选联系电话",
  "Organization Info": "组织信息",
  "Once a day, we start an OpenTimestamps stamp for all pending hashes.": "每天一次，我们为所有待处理的哈希启动 OpenTimestamps 时间戳。",
  "Once confirmed, we write the timestamp into your repository and show it in your status badge.": "确认后，我们将时间戳写入您的仓库并显示在您的状态徽章中。",
  "Our bot directly pushes the cryptographic proofs to the client's repository.": "我们的机器人直接将加密证明推送到客户的仓库。",
  "Our service relies on the Bitcoin network. We are not responsible for delays caused by network congestion or protocol changes in the underlying blockchain.": "我们的服务依赖比特币网络。对于由网络拥堵或底层区块链协议变更造成的延迟，我们概不负责。",
  "Output": "输出",
  "Paste concatenated hex string here (Left + Middle + Right)...": "在此粘贴拼接的十六进制字符串（左 + 中 + 右）...",
  "Patent Troll Defense": "专利流氓防御",
  "Paused": "已暂停",
  "Pending Bitcoin Block": "待确认的比特币区块",
  "Perfect for solo developers and public open-source projects.": "非常适合个人开发者和公共开源项目。",
  "Phone": "电话",
  "Phone:": "电话：",
  "Prefix": "前缀",
  "Prepend (Left)": "前置（左）",
  "Pricing": "价格",
  "Prior Art": "现有技术",
  "Prior Art Proofs": "现有技术证明",
  "Priority Mempool Anchoring": "优先内存池锚定",
  "Privacy Policy": "隐私政策",
  "Private": "私有",
  "Private Repositories": "私有仓库",
  "Private Shadow Repos": "私有影子仓库",
  "Private Shadow Repositories": "私有影子仓库",
  "Pro Agency": "Pro Agency",
  "Pro Tip": "专业提示",
  "Problem": "问题",
  "Processing payments and providing customer support.": "处理付款并提供客户支持。",
  "Professional \"Certificate of Authorship\" handoffs.": "专业的“作者身份证书”交接。",
  "Proof": "证明",
  "Proof Longevity": "证明长期有效性",
  "Proofs": "证明",
  "Protect trade secrets without filing public docs.": "无需提交公开文件即可保护商业秘密。",
  "Protect your intellectual property from patent trolls and IP theft with globally recognized cryptographic standards.": "使用全球公认的加密标准，保护您的知识产权免受专利流氓和知识产权盗窃的侵害。",
  "Protected": "已保护",
  "Prove work-delivery dates during payment disputes.": "在付款纠纷中证明工作交付日期。",
  "Public": "公共",
  "Public Badges:": "公共徽章：",
  "Public Base URL": "公共基础 URL",
  "Public Shields.io Badge": "公共 Shields.io 徽章",
  "Pushing ": "正在推送 ",
  "Questions about the Terms of Service should be sent to:": "有关服务条款的问题应发送至：",
  "Quick Start": "快速开始",
  "RSJ Software GmbH": "RSJ Software GmbH",
  "Read-Only Access": "只读访问",
  "Ready: {{file}}": "就绪：{{file}}",
  "Recreating the GitHub App will invalidate all existing app installations. All users who previously installed the app will need to re-install it, and all timestamp data linked to the old app will be orphaned. Only proceed if you are absolutely certain.": "重新创建 GitHub App 将使所有现有的应用安装失效。之前安装过该应用的所有用户都需要重新安装，且所有与旧应用关联的时间戳数据将成为孤儿数据。只有在完全确定的情况下才继续。",
  "Refunds:": "退款：",
  "Registered to RSJ Software GmbH": "注册至 RSJ Software GmbH",
  "Registry & Tax": "登记与税务",
  "Replace File": "替换文件",
  "Repositories currently being tracked automatically via the GitHub App.": "当前通过 GitHub App 自动跟踪的仓库。",
  "Repositories unavailable": "仓库不可用",
  "Repository": "仓库",
  "Repository Connected!": "仓库已连接！",
  "Repository Metadata:": "仓库元数据：",
  "Repository names, commit timestamps, and standard Git author metadata.": "仓库名称、提交时间戳和标准 Git 作者元数据。",
  "Request Docker License": "申请 Docker 许可证",
  "Request Submitted": "申请已提交",
  "Request a Demo License": "申请演示许可证",
  "Required for GitHub Webhook callbacks.": "GitHub Webhook 回调所需。",
  "Resources": "资源",
  "Resume": "继续",
  "Retained as long as your account is active or needed to comply with legal obligations.": "只要您的账户处于活跃状态或需要遵守法律义务，将一直保留。",
  "Reverse Byte Order (Little-Endian / Big-Endian)": "反转字节序（小端 / 大端）",
  "Revoke": "撤销",
  "Row 1 \"Current Result\" is your local Git commit hash.": "第 1 行“当前结果”是您的本地 Git 提交哈希。",
  "Ruediger Jungbeck": "Ruediger Jungbeck",
  "Running GitHub Enterprise Server or GitLab Self-Managed? Deploy the entire Timestamp GIT engine behind your own firewall using our official Docker image. Perfect for heavily regulated industries.": "正在运行 GitHub Enterprise Server 或 GitLab Self-Managed？使用我们的官方 Docker 镜像，在您自己的防火墙后面部署完整的 Timestamp GIT 引擎。非常适合监管严格的行业。",
  "Sample Integration": "示例集成",
  "Save 20%": "节省 20%",
  "Save Configuration": "保存配置",
  "Search repositories...": "搜索仓库...",
  "Secure \"Prior Art\" before a patent filing.": "在专利申请前保护“现有技术”。",
  "Secure Your Prior Art": "保护您的现有技术",
  "Secure portfolio pieces against plagiarism.": "保护作品集作品免受剽窃。",
  "Security Protocol": "安全协议",
  "Select a repository to view its timestamp verification status and proof history.": "选择一个仓库以查看其时间戳验证状态和证明历史。",
  "Self-Hosted / Air-Gapped": "自托管 / 气隙隔离",
  "Sending service updates and security alerts.": "发送服务更新和安全警报。",
  "Service Providers:": "服务提供商：",
  "Settings Applied": "设置已应用",
  "Severing connections to GitHub and deleting personal metadata from our active databases.": "切断与 GitHub 的连接并从我们的活动数据库中删除个人元数据。",
  "Shadow Repo": "影子仓库",
  "Shadow Repository Configuration:": "影子仓库配置：",
  "Shield the agency from liability if clients are sued.": "在客户被起诉时保护代理机构免于承担责任。",
  "Show the world your intellectual property is protected. Copy the Markdown below and paste it at the top of your ": "向世界展示您的知识产权受到保护。复制下面的 Markdown 并粘贴到您的 ",
  "Show your users this project is protected": "向您的用户展示此项目已受保护",
  "Simple, Transparent Pricing": "简单透明的定价",
  "Since blockchain anchoring incurs immediate, irreversible computational and transaction costs, we generally do not offer refunds once hashes have been anchored.": "由于区块链锚定会产生即时且不可逆的计算和交易成本，一旦哈希被锚定，我们通常不提供退款。",
  "Software development moves at light speed, creating three critical legal and strategic blindspots.": "软件开发以光速发展，产生了三个关键的法律和战略盲点。",
  "Standard Git history is stored on servers you do not own (GitHub) or databases you can edit (Local). In a serious legal audit, internal logs are often dismissed as \"self-serving\" or \"manipulatable.\"": "标准 Git 历史存储在您不拥有的服务器（GitHub）或您可以编辑的数据库（本地）中。在严肃的法律审计中，内部日志常被认定为“自我服务”或“可篡改”而不予采信。",
  "Standard Mode": "标准模式",
  "Standard Mode Repositories": "标准模式仓库",
  "Standard cookies to maintain user sessions and analyze site traffic.": "用于维持用户会话和分析网站流量的标准 Cookie。",
  "Status Badge": "状态徽章",
  "Status Badges": "状态徽章",
  "Star": "Star",
  "Start Securing Prior Art": "开始保护现有技术",
  "Start for Free": "免费开始",
  "Start:": "开始：",
  "Startups & Founders": "初创企业与创始人",
  "Status": "状态",
  "Stop Tracking": "停止跟踪",
  "Store": "存储",
  "Submit Request": "提交申请",
  "Super Awesome AI": "Super Awesome AI",
  "Support Data:": "支持数据：",
  "System Online": "系统在线",
  "TO THE MAXIMUM EXTENT PERMITTED BY LAW, RSJ SOFTWARE GMBH SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, OR CONSEQUENTIAL DAMAGES, INCLUDING LOSS OF PROFITS OR DATA. OUR TOTAL LIABILITY FOR ANY CLAIM SHALL NOT EXCEED THE TOTAL FEES PAID BY YOU IN THE 12 MONTHS PRIOR TO THE CLAIM.": "在法律允许的最大范围内，RSJ SOFTWARE GMBH 对任何间接、偶然、特殊或后果性损害（包括利润或数据损失）概不负责。我们对任何索赔的总责任不超过您在索赔前 12 个月内支付的总费用。",
  "Target Git Commit": "目标 Git 提交",
  "Tax ID: 117/136/80100": "税号：117/136/80100",
  "Terms at a Glance": "条款概览",
  "Terms of Service": "服务条款",
  "Thank you for your interest. We will review your request and send a demo license file to your email address within one business day.": "感谢您的关注。我们将审核您的申请，并在一个工作日内将演示许可证文件发送到您的邮箱。",
  "The \"Clean Room\" Fallacy": "“洁净室”谬误",
  "The Anchor": "锚定",
  "The Bitcoin Blockchain:": "比特币区块链：",
  "The Fingerprint": "指纹",
  "The Fragility of Logs": "日志的脆弱性",
  "The OpenTimestamps protocol anchors the Merkle root of the daily batch into a Bitcoin block.": "OpenTimestamps 协议将每日批次的 Merkle 根锚定到比特币区块中。",
  "The Patent Troll Threat": "专利流氓威胁",
  "The Proof": "证明",
  "The Proof of Existence Gap": "存在证明的空白",
  "The SHA-256 (or similar) hashes of your Git commits.": "您的 Git 提交的 SHA-256（或类似）哈希。",
  "The Timestamp GIT dashboard, API, and Docker images are the intellectual property of RSJ Software GmbH. You are granted a non-exclusive, non-transferable license to use these services according to your subscription tier.": "Timestamp GIT 仪表板、API 和 Docker 镜像是 RSJ Software GmbH 的知识产权。您被授予根据您的订阅层级使用这些服务的非独占、不可转让许可。",
  "The Vulnerability of \"New\"": "“新”的脆弱性",
  "The requested Docker license is a time-limited demo license for evaluation purposes.": "所申请的 Docker 许可证是用于评估目的的限时演示许可证。",
  "The application will be available at http://localhost:8080 after startup. On first launch, follow the setup wizard to connect your GitHub App and configure your instance.": "启动后，应用程序将在 http://localhost:8080 可用。首次启动时，请按照设置向导连接您的 GitHub App 并配置您的实例。",
  "The cryptographic proof relies entirely on Bitcoin math. You can verify it locally even if our company disappears.": "加密证明完全依赖于比特币数学。即使我们的公司消失，您也可以在本地验证它。",
  "The full mathematical path mapping your commit to Bitcoin. Concatenate strings, hash via SHA-256, and pass the result down.": "将您的提交映射到比特币的完整数学路径。拼接字符串，通过 SHA-256 哈希，然后传递结果。",
  "This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website, use our SaaS platform, interact with our GitHub App, or utilize our Enterprise Docker containers (collectively, the \"Services\").": "本隐私政策说明了当您访问我们的网站、使用我们的 SaaS 平台、与我们的 GitHub App 交互或使用我们的企业版 Docker 容器（统称“服务”）时，我们如何收集、使用、披露和保护您的信息。",
  "This data is public and immutable.": "此数据是公开且不可变的。",
  "This is the ": "这是 ",
  "This project provides next-generation machine learning tools for edge devices.": "该项目为边缘设备提供下一代机器学习工具。",
  "This provides mathematically undeniable proof of prior art and authorship for all code and ideas contained within.": "这为其中包含的所有代码和创意提供了数学上无可辩驳的现有技术和作者身份证明。",
  "This public ledger provides mathematically undeniable evidence of the repository's existence over time.": "这份公开账本提供了仓库随时间存在的数学上无可辩驳的证据。",
  "Timestamp Branch / Private Shadow Repo": "时间戳分支 / 私有影子仓库",
  "Timestamp GIT": "Timestamp GIT",
  "Timestamp GIT Enterprise is distributed as a Docker image. Use the following Docker Compose configuration to get started:": "Timestamp GIT Enterprise 以 Docker 镜像形式分发。使用以下 Docker Compose 配置开始：",
  "Timestamp GIT provides a technical service. The eventual \"legal weight\" of the evidence provided depends on the jurisdiction and the specific requirements of the court or authority. We provide the math; you provide the context.": "Timestamp GIT 提供技术服务。所提供证据的最终“法律效力”取决于司法管辖区以及法院或当局的具体要求。我们提供数学，您提供背景。",
  "Timestamp GIT provides cryptographic proof-of-existence for digital files and Git commits. Our service calculates hashes, aggregates them into Merkle trees, and anchors the resulting Merkle Root into the Bitcoin blockchain via the OpenTimestamps protocol.": "Timestamp GIT 为数字文件和 Git 提交提供加密的存在证明。我们的服务计算哈希，将它们聚合为 Merkle 树，并通过 OpenTimestamps 协议将生成的 Merkle 根锚定到比特币区块链。",
  "Timestamp any content that is illegal, defamatory, or violates third-party IP rights.": "请勿对任何非法、诽谤或侵犯第三方知识产权的内容进行时间戳标记。",
  "To Communicate:": "用于沟通：",
  "To Deliver Proofs:": "用于交付证明：",
  "To Improve Our Platform:": "用于改进我们的平台：",
  "To Manage Your Account:": "用于管理您的账户：",
  "To Provide the Service:": "用于提供服务：",
  "Today, 00:05 UTC": "今天，00:05 UTC",
  "Toggle color scheme": "切换配色方案",
  "Top Merkle Root": "顶层 Merkle 根",
  "Total Proofs": "证明总数",
  "Trade Register: Munich HRB 76084": "商业登记：慕尼黑 HRB 76084",
  "Traditional IP protection is broken. It is either too expensive (Patents) or too weak (Internal Logs). Timestamp GIT creates a new mathematical middle ground.": "传统的知识产权保护已经失效。要么过于昂贵（专利），要么过于薄弱（内部日志）。Timestamp GIT 创造了一个新的数学中间地带。",
  "Transaction Hash": "交易哈希",
  "Transparency:": "透明度：",
  "Timestamp recorded": "时间戳已记录",
  "Trial Mode Active": "试用模式已激活",
  "Trust Math, Not Servers": "相信数学，而非服务器",
  "Trusted third-party vendors (e.g., AWS, Stripe).": "受信任的第三方供应商（例如 AWS、Stripe）。",
  "Unlimited Private Repositories": "无限私有仓库",
  "Unlimited Public Repositories": "无限公共仓库",
  "Unlimited Repositories": "无限仓库",
  "Update README.md with Timestamp GIT badges": "使用 Timestamp GIT 徽章更新 README.md",
  "Upload .lic file": "上传 .lic 文件",
  "Usage": "使用情况",
  "Use the API or GitHub Action in a way that causes excessive load or \"spamming\" of the Bitcoin mempool.": "以导致比特币内存池过度负载或“垃圾信息”的方式使用 API 或 GitHub Action。",
  "Use these API keys in your CI/CD pipelines (GitHub Actions, GitLab CI, Jenkins) to push commit hashes securely.": "在您的 CI/CD 流水线（GitHub Actions、GitLab CI、Jenkins）中使用这些 API 密钥安全地推送提交哈希。",
  "VAT-ID: DE 128 239 592": "增值税号：DE 128 239 592",
  "VERIFY MATHEMATICS": "验证数学",
  "VIEW MATHEMATICAL PATH": "查看数学路径",
  "VS": "VS",
  "ValKey": "ValKey",
  "Vendor Independent": "供应商无关",
  "Verification": "验证",
  "Verification is powered by the OpenTimestamps protocol anchored into the Bitcoin Blockchain.": "验证由锚定到比特币区块链的 OpenTimestamps 协议驱动。",
  "Verify": "验证",
  "Version": "版本",
  "Version:": "版本：",
  "View in GitHub": "在 GitHub 中查看",
  "Viral Badges": "病毒式徽章",
  "Warning: Recreating the GitHub App": "警告：重新创建 GitHub App",
  "Watch": "Watch",
  "We are beta-testing the Pro Agency plan, so the Free plan currently includes every Pro feature at no cost. When the beta ends on 31 December 2026, the Free plan returns to its standard feature set and the Pro limits are enforced again.": "我们正在对 Pro Agency 方案进行测试，因此 Free 方案目前免费包含所有 Pro 功能。测试于 2026 年 12 月 31 日结束后，Free 方案将恢复为标准功能集，Pro 方案的限制将再次生效。",
  "We are now actively tracking ": "我们现在正在积极跟踪 ",
  "We could not load your repositories at the moment.": "我们目前无法加载您的仓库。",
  "We do not collect telemetry or hashes from your internal instances.": "我们不会从您的内部实例收集遥测数据或哈希。",
  "We do not read, copy, store, or transmit your actual source code.": "我们不会读取、复制、存储或传输您的实际源代码。",
  "We do not sell your personal information. We may share your information only in the following specific circumstances:": "我们不出售您的个人信息。仅在以下特定情况下，我们可能会共享您的信息：",
  "We extract only the hash and cryptographically embed it into a Bitcoin transaction, freezing its existence in time.": "我们只提取哈希，并将其以加密方式嵌入比特币交易中，从而将它的存在冻结在时间中。",
  "We may suspend or terminate your account if you violate these Terms. Upon termination, your access to the dashboard and API will cease. Existing ": "如果您违反这些条款，我们可能会暂停或终止您的账户。终止后，您对仪表板和 API 的访问将停止。现有的 ",
  "We may update this Privacy Policy from time to time. We will notify you of material changes by posting the updated policy on this page.": "我们可能会不时更新本隐私政策。我们将通过在本页面发布更新后的政策来通知您重大变更。",
  "We never see, copy, or store your actual source code. We only mathematically stamp the public Git hash.": "我们永远不会查看、复制或存储您的实际源代码。我们只对公共 Git 哈希进行数学时间戳标记。",
  "We provide mathematical evidence, not legal representation.": "我们提供数学证据，而非法律代理。",
  "We turn your everyday Git commits into irrefutable legal evidence. Prove exactly ": "我们将您的日常 Git 提交变成无可辩驳的法律证据。准确证明 ",
  "We use the collected information for the following purposes:": "我们将收集的信息用于以下目的：",
  "Web:": "网站：",
  "Webhooks": "Webhooks",
  "Welcome to Timestamp GIT. These Terms of Service (\"Terms\") govern your access to and use of our platform, APIs, GitHub App, and Docker containers. By using Timestamp GIT, you agree to be bound by these Terms.": "欢迎使用 Timestamp GIT。本服务条款（“条款”）管辖您对我们平台、API、GitHub App 和 Docker 容器的访问和使用。使用 Timestamp GIT 即表示您同意受这些条款的约束。",
  "Welcome to the official repository for": "欢迎访问以下项目的官方仓库：",
  "What's included": "包含内容",
  "When a lead developer leaves, disputes often arise over when a specific feature or algorithm was conceived. Without an immutable timestamp, it becomes a \"he-said, she-said\" battle in court.": "当首席开发人员离开时，关于特定功能或算法是何时构思的，常常会产生争议。如果没有不可变的时间戳，就会变成法庭上的“他说她说”之争。",
  "When users click these badges on your GitHub page, they will be redirected to your public cryptographic verification ledger, proving your undeniable prior art ownership.": "当用户点击您 GitHub 页面上的这些徽章时，他们将被重定向到您的公共加密验证账本，证明您无可辩驳的现有技术所有权。",
  "When you commit code, Git generates a unique, one-way hash representing the exact state of your entire repository.": "当您提交代码时，Git 会生成一个表示整个仓库精确状态的唯一单向哈希。",
  "Whether you use our Standard Mode (GitHub App) or Enterprise ZK Mode (GitHub Actions/Docker), our systems only extract, receive, and process cryptographic hashes (e.g., SHA-256) of your Git commits.": "无论您使用我们的标准模式（GitHub App）还是企业版 ZK 模式（GitHub Actions/Docker），我们的系统都只会提取、接收和处理您 Git 提交的加密哈希（例如 SHA-256）。",
  "While commit hashes are opaque, the fact that a specific hash was anchored at a specific time is a public record.": "虽然提交哈希是不透明的，但特定哈希在特定时间被锚定这一事实是公开记录。",
  "While we do not collect your source code, we do collect standard business and metadata necessary to provide and secure our Services:": "虽然我们不收集您的源代码，但我们会收集提供和保护我们的服务所必需的标准业务数据和元数据：",
  "Who is this for?": "这是为谁准备的？",
  "Why Proving \"When\" Is Just As": "为什么证明“何时”与“什么”同样重要",
  "Without Exposing Code": "无需暴露代码",
  "Workspace Configuration": "工作区配置",
  "Write Access": "写入权限",
  "Years": "年",
  "You agree not to use the Service to:": "您同意不使用本服务进行：",
  "You can install the package via pip:": "您可以通过 pip 安装该包：",
  "You can upgrade or downgrade your plan at any time. Downgrades take effect at the end of the current billing cycle.": "您可以随时升级或降级您的套餐。降级将在当前计费周期结束时生效。",
  "You own your code. We never read it; we only see the hashes.": "代码归您所有。我们从不阅读它；我们只看到哈希。",
  "You receive an immutable `.ots` receipt. You can now mathematically prove to any lawyer, auditor, or court that your idea existed on this date.": "您将收到一份不可变的 `.ots` 收据。现在您可以向任何律师、审计师或法院数学地证明您的创意在这一天已经存在。",
  "You retain all ownership rights to your source code and data. Timestamp GIT does not claim any license or ownership over the content you timestamp.": "您保留对源代码和数据的全部所有权。Timestamp GIT 不对您进行时间戳标记的内容主张任何许可或所有权。",
  "Your Code:": "您的代码：",
  "Your Repositories": "您的仓库",
  "ZK Timestamp URL": "ZK 时间戳 URL",
  "Generate the authenticated POST URL that your CI/CD pipeline can use to timestamp commits without exposing your source code.": "生成经认证的 POST URL，您的 CI/CD 管道可以用它在不暴露源代码的情况下为提交添加时间戳。",
  "Owner": "所有者",
  "Target Repository": "目标仓库",
  "Generate URL": "生成 URL",
  "POST URL": "POST URL",
  "Append the commit SHA to this URL to timestamp a commit.": "将提交 SHA 附加到此 URL 即可为提交添加时间戳。",
  "Example:": "示例：",
  "Repository and target repository are required.": "仓库和目标仓库为必填项。",
  "This feature requires a ZK or Admin subscription.": "此功能需要 ZK 或 Admin 订阅。",
  "The Zero-Knowledge commit API is available with ZK and Admin subscriptions.": "零知识提交 API 适用于 ZK 和 Admin 订阅。",
  "View Pricing": "查看定价",
  "Your subscription does not allow generating this URL.": "您的订阅不允许生成此 URL。",
  "Could not generate the URL. Please try again.": "无法生成 URL。请重试。",
  "Copied": "已复制",
  "Copy URL": "复制 URL",
  "Your cryptographic proofs are embedded in the Bitcoin blockchain.": "您的加密证明已嵌入比特币区块链。",
  "Your company or organization": "您的公司或组织",
  "Your first cryptographic anchor is pending in the daily batch.": "您的第一个加密锚定正在每日批次中等待处理。",
  "Your full name": "您的全名",
  "Zero Code Access": "零代码访问",
  "Zero Knowledge Architecture": "零知识架构",
  "Zero-Knowledge API Keys": "零知识 API 密钥",
  "Zero-Knowledge GitHub Action": "零知识 GitHub Action",
  "Zero-Knowledge Pipeline": "零知识流水线",
  "Zero-Knowledge Security": "零知识安全",
  "Zero-Knowledge Timestamp Architecture": "零知识时间戳架构",
  "Zero-Knowledge: We never read code. We only mathematically stamp the hash.": "零知识：我们从不阅读代码。我们只对哈希进行数学时间戳标记。",
  "aiohttp": "aiohttp",
  "cannot be deleted, modified, or removed": "无法被删除、修改或移除",
  "file.": "文件。",
  "is your primary shield to invalidate these claims.": "是您使这些主张无效的主要盾牌。",
  "isolated, private GitHub repository": "隔离的私有 GitHub 仓库",
  "when": "何时"
}
